import { LogOut, ShieldCheck } from 'lucide-react';
import type { ReactNode } from 'react';
import { useAuth } from '../context/AuthContext';
import { useHealth } from '../hooks/useHealth';

import { roleLabels } from '../utils/roles';

type LayoutProps = {
  children: ReactNode;
};

export function Layout({ children }: LayoutProps) {
  const { employee, role, logout } = useAuth();
  const { healthy } = useHealth();

  return (
    <div className="app-shell">
      <header className="nav admin-nav">
        <div className="nav-brand">
          <ShieldCheck size={18} aria-hidden />
          Onyx Pay
        </div>
        <span className="nav-subtitle">Master Admin</span>
        <div className="nav-spacer" />
        <div className="api-status-pill">
          <div
            className="api-status-dot"
            data-state={healthy === true ? 'ok' : healthy === false ? 'err' : 'unknown'}
          />
          <span>
            {healthy ? 'System operational' : healthy === false ? 'API degraded' : 'Checking…'}
          </span>
        </div>
        {employee ? (
          <div className="nav-user">
            <span className="nav-user-name">{employee.name || employee.email}</span>
            <span className="nav-user-role">{role ? (roleLabels[role] ?? role) : ''}</span>
          </div>
        ) : null}
        <button type="button" className="btn-logout" onClick={logout}>
          <LogOut size={16} aria-hidden />
          Выйти
        </button>
      </header>
      <main className="panel active console-root">{children}</main>
    </div>
  );
}
